/**
 * Helpers purs pour parser les headers Gmail. Aucune dépendance — peut
 * être importé depuis le service worker (cf. `service-worker.ts` pour
 * l'enrichissement des notifications push) en plus du code page.
 *
 * Le shape `MessageWithHeaders` est un sous-ensemble structurel de
 * `GmailMessage` (cf. api.ts) — un objet avec `payload.headers[]` —, ce
 * qui évite d'importer le type complet (et donc d'éviter une dépendance
 * cyclique entre `headers.ts` et `api.ts`).
 */

interface MessageWithHeaders {
  payload?: {
    headers?: Array<{ name: string; value: string }>;
  };
}

/** Extrait la valeur d'un header (case-insensitive, premier match). */
export function getHeader(msg: MessageWithHeaders, name: string): string | null {
  const headers = msg.payload?.headers ?? [];
  const lower = name.toLowerCase();
  const h = headers.find((h) => h.name.toLowerCase() === lower);
  return h?.value ?? null;
}

/** Parse un header `From:` "Nom <email@x>" → { name, email }. */
export function parseFrom(raw: string | null): { name: string; email: string } {
  if (!raw) return { name: "", email: "" };
  const trimmed = raw.trim();
  const match = trimmed.match(/^"?([^"<]*?)"?\s*<([^>]+)>$/);
  if (match) {
    return { name: match[1].trim(), email: match[2].trim() };
  }
  // Pas de < > → c'est juste un email
  return { name: "", email: trimmed };
}
